import React, { useEffect, useState } from "react";

import { calculatePrices } from 'frontend/js/helpers';

export const MinicartLineItem = ({ item, settings, globals }) => {
  const [prices, setPrices] = useState(null);
  const LayoutComponent: any = 'ajax-cart-quantity';
  const {
    savings_badge_label,
    savings_badge_bundle_label,
    savings_badge_label_style
  } = globals?.savings_badge || {};

  const {
    show_vendor = false,
    show_total_price = true,
    show_savings_pill = true,
    show_variant_options = false,
    product_title_style = "h4",
    price_style = "h4",
    variant_option_style = "text-sm",
    item_background_color = "#ffffff",
    item_border_radius = "4px",
  } = settings;

  const itemStyle = {
    backgroundColor: item_background_color,
    borderRadius: item_border_radius,
    display: "flex",
    alignItems: "flex-start"
  };

  const formatMoney = (cents) => {
    const dollars = cents / 100;
    return dollars.toLocaleString('en-US', {
      style: 'currency',
      currency: 'USD',
    });
  };

  useEffect(() => {
    async function getPrices() {
      let pricesData = await calculatePrices(item.product);

      if (item.selling_plan_allocation) {
        const { price, compare_at_price } = item.selling_plan_allocation;
        pricesData = {
          ...pricesData,
          productPrice: (price / 100).toFixed(2),
          savings: price / compare_at_price * 100,
        }
      }

      setPrices(pricesData);
    }

    getPrices();
  }, []);

  return (
    <li className="minicart-items__item  lg:h-[160px] border-t border-gray-200 lg:first:border-t-0 mt-2 pt-2 lg:pt-[6px] first:mt-0 lg:first:pt-0" style={itemStyle}>
      <div className="minicart-items__item-image mr-4 my-auto flex-shrink-0 flex h-full items-center justify-center">
        <img
          src={item.image}
          alt={item.product_title}
          className=" w-[80px] lg:w-[186px]  h-[80px] lg:h-[160px] object-contain"
          style={{ borderRadius: item_border_radius }}
        />
      </div>

      <div className="minicart-items__item-content flex flex-auto flex-col gap-2 lg:gap-0 lg:justify-between h-full px-2 py-2 lg:py-3">
        <div className="flex justify-between">
          <div>
            {show_vendor && item.vendor && (
              <div className="vendor text-sm text-gray-500 mb-1">{item.vendor}</div>
            )}

            <a href={`${item.url}`}><h3 className={product_title_style}>{item.product_title}</h3></a>

            {item?.selling_plan_allocation?.selling_plan?.name && (
              <div className="b4">
                {item?.selling_plan_allocation?.selling_plan?.name }
              </div>
            )}

            {show_variant_options && item.options_with_values && item.options_with_values.length > 0 && (
              <div className="variants mb-2">
                {item.options_with_values.map((option, optIndex) => (
                  <div key={optIndex} className={variant_option_style}>
                    {option.name}: {option.value}
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>

        <div className="flex flex-col gap-3">
          <div className="flex gap-2 items-center justify-between">
            {(show_total_price && prices) && (
              <div className="flex gap-2">
                <div className={`price ${price_style}`}>
                  ${prices?.productPrice}
                </div>

                {!!prices?.savings &&
                  <s className={`price text-[#AAA] ${price_style}`}>
                    ${((prices?.singlePrice * prices?.quantityInBundle) / 100).toFixed(2)}
                  </s>
                }
              </div>
            )}

            {(show_savings_pill && !!prices?.savings && prices?.isBundle) &&
              <div className={`savings-badge ${savings_badge_label_style}`}>
                <span>
                  {prices.discountType === 'bundle'
                    ? savings_badge_bundle_label
                    : savings_badge_label
                  }
                </span>
                <span>{Math.round(prices.savings)}%</span>
              </div>
            }
          </div>

          <div className="flex w-full justify-between gap-4">
            {<LayoutComponent className="flex flex-auto">

              <div className="quantity flex max-h-[36px] lg:max-h-[40px] w-[120px] lg:w-[140px] items-center justify-center text-center border border-black py-[6px] px-3 lg:py-2 lg:px-3 rounded-full">
                <button
                  data-ajax-cart-quantity-minus
                  className="flex items-center w-auto h-auto p-1 border-none"
                >
                  <span className="icon-minus text-[24px]"></span>
                </button>
                <input
                  type="number"
                  value={`${item.quantity}`}
                  name="updates[]"
                  data-ajax-cart-quantity-input={`${item.key}`}
                  className="border-none text-center outline-none focus:border-none !text-[14px] border-white  focus:outline-none active:outline-none "
                  readOnly={true}
                />
                <button
                  data-ajax-cart-quantity-plus
                  className="flex items-center w-auto h-auto p-1 border-none"
                >
                  <span className="icon-plus text-[24px]"></span>
                </button>
              </div>
            </LayoutComponent>}
            <div
              className="flex flex-col justify-end"
              data-ajax-cart-request-button={`/cart/change?id=${item.key}&quantity=0`}
            >
              <button
                className="remove-item b4 justify-end underline"
                data-item-key={item.key}
              >
                Remove
              </button>
            </div>

          </div>
        </div>
      </div>
    </li>
  )
}